import constants from 'constants';
const {
  ADD_HOSPITAL_SUGGESTIONS,
  LOAD_HOSPITALS_SAGA,
  NEW_HOSPITAL_SUGGESTION,
  LOAD_COUNTIES_SAGA,
  ADD_COUNTY_SUGGESTIONS,
  ADD_SPONSOR_SUGGESTIONS,
  LOAD_SPONSORS_SUGGESTIONS_SAGA
} = constants;

export const addHospitalSuggestions = (q, suggestions) => ({
  type: ADD_HOSPITAL_SUGGESTIONS,
  q,
  suggestions
})

export const newHospitalSuggestion = (suggestion) => ({
  type: NEW_HOSPITAL_SUGGESTION,
  suggestion
})

export const loadHospitalsSaga = (q) => ({
  type: LOAD_HOSPITALS_SAGA,
  q
})

export const loadCountiesSaga = () => ({
  type: LOAD_COUNTIES_SAGA
})

export const loadSponsorsSuggestionsSaga = (q = '') => ({
  type: LOAD_SPONSORS_SUGGESTIONS_SAGA,
  q
})

export const addCountySuggestions = (suggestions) => ({
  type: ADD_COUNTY_SUGGESTIONS,
  suggestions
})

export const addSponsorSuggestions = (suggestions) => ({
  type: ADD_SPONSOR_SUGGESTIONS,
  suggestions
})



/** WEBPACK FOOTER **
 ** ./src/actions/suggestions.js
 **/